export default {
  categories: {
    shoes: 'Buty',
    hoodies: 'Bluzy / Swetry',
    tshirts: 'Koszulki',
    jackets: 'Kurtki',
    pants: 'Spodnie / Szorty',
    headwear: 'Nakrycia głowy',
    sets: 'Zestawy',
    underwear: 'Bielizna',
    jersey: 'Koszulki sportowe',
    accessories: 'Akcesoria',
    bags: 'Torby',
    belts: 'Paski',
    perfumes: 'Perfumy',
    other: 'Inne',
  },
  home: {
  hero: {
    badge: 'Niezależne źródło o arkuszu USFans',
    h1: 'Arkusz USFans — linki do produktów, QC i poradniki zakupowe',
    subtitle: 'Poznaj arkusz USFans: zasoby produktowe, przydatne linki, informacje QC, poradniki wysyłki, szczegóły magazynu, opinie, kupony i praktyczne wskazówki — wszystko w jednym miejscu.',
    searchPlaceholder: 'Szukaj produktów USFans, linków arkusza, QC, wysyłki lub poradników...',
    ctaPrimary: 'Arkusz USFans',
    ctaSecondary: 'Kup teraz',
    dropdownLabel: 'Wybierz kategorię',
    dropdownHint: 'Przejdź do kategorii na głównej stronie',
    trustLine: 'Darmowe źródło · Bez konta · Regularnie aktualizowane',
  },
  intro: {
    title: 'Czym jest arkusz USFans?',
    p1: 'Arkusz USFans to scentralizowane, uporządkowane źródło, które gromadzi linki do produktów, szczegóły kontroli jakości (QC), informacje o wysyłce i wskazówki zakupowe dla miłośników streetwearu i mody. Zamiast przekopywać się przez dziesiątki stron, kupujący używają jednego czytelnego dokumentu, aby porównać produkty i znaleźć dokładnie to, czego potrzebują.',
    p2: 'To praktyczny punkt wyjścia: wybierz kategorię, przejrzyj pozycje, sprawdź notatki QC i rozmiarów, a następnie otwórz wybrany link na głównej stronie. Wszystko, czego potrzebujesz do pewnego zakupu, jest w jednym miejscu.',
    point1: 'Linki do produktów pogrupowane według kategorii',
    point2: 'Odniesienia QC i rozmiarów',
    point3: 'Wskazówki dotyczące wysyłki i magazynu',
    point4: 'Informacje o kuponach i rabatach',
  },
  categoriesSection: {
    title: 'Popularne kategorie',
    subtitle: 'Otwórz dowolną kategorię poniżej, aby przeglądać pasujące produkty na głównej stronie.',
  },
  qc: {
    title: 'QC i kontrola jakości',
    body: 'QC oznacza kontrolę jakości. Zanim towar zostanie wysłany, kupujący często przeglądają zdjęcia, aby potwierdzić kolor, logo, szwy, rozmiar i ogólny stan. Dobra rutyna QC to sprawdzanie wymiarów względem tabeli rozmiarów i prośba o wyraźniejsze zdjęcia, gdy coś wygląda niejasno.',
    item1: 'Przeglądaj zdjęcia przed wysyłką',
    item2: 'Sprawdź wymiary względem tabeli rozmiarów',
    item3: 'Poproś o nowe zdjęcia, gdy szczegóły są niejasne',
    item4: 'Potwierdź kolor, logo i szwy',
  },
  review: {
    title: 'Opinia o USFans — czy to legalne?',
    body: 'USFansLink.site to niezależne źródło informacji, a nie oficjalna strona marki. Bezpieczeństwo zakupu zależy od weryfikacji sprzedawcy, czytania opinii z kilku źródeł i korzystania z bezpiecznych metod płatności.',
    legitTitle: 'Legalne i bezpieczne zakupy',
    legit1: 'Zweryfikuj sprzedawcę przed płatnością',
    legit2: 'Czytaj opinie z wielu źródeł',
    legit3: 'Korzystaj z bezpiecznych, możliwych do śledzenia płatności',
    legit4: 'Uważaj na podejrzane linki',
  },
  shipping: {
    title: 'Koszt wysyłki i dostawa',
    body: 'Koszt wysyłki i czas dostawy zależą od miejsca docelowego, metody wysyłki i rozmiaru paczki. Niektórzy kupujący łączą kilka przedmiotów przez magazyn, aby obniżyć całkowity koszt.',
    item1: 'Potwierdź koszt wysyłki przed zamówieniem',
    item2: 'Sprawdź szacowany czas dostawy do swojego kraju',
    item3: 'Rozważ konsolidację magazynową dla wielu przedmiotów',
  },
  warehouse: {
    title: 'Magazyn i przechowywanie',
    body: 'Zamówienia są zwykle pakowane i sprawdzane w magazynie przed wysyłką. Usługi magazynowe mogą przechowywać, kontrolować i łączyć przedmioty, dzięki czemu wysyłasz kilka produktów razem i płacisz mniej.',
  },
  coupon: {
    title: 'Kupony i rabaty',
    body: 'Kody kuponów często się zmieniają, więc traktuj każdy kod jako tymczasowy. Przetestuj go przy kasie i korzystaj tylko z kodów z zaufanych źródeł. Arkusz może wskazać aktualne oferty lub wyjaśnić, gdzie publikowane są rabaty.',
  },
  safety: {
    title: 'Centrum bezpieczeństwa',
    body: 'Bądź bezpieczny podczas zakupów: unikaj fałszywych stron, weryfikuj linki, chroń dane płatności i sprawdzaj oferty, które wyglądają zbyt dobrze, by były prawdziwe.',
    item1: 'Uważaj na fałszywe lub podrobione strony',
    item2: 'Nigdy nie udostępniaj nieostrożnie haseł ani danych płatności',
    item3: 'Weryfikuj kody kuponów przed kasą',
    item4: 'Sprawdzaj podejrzane linki',
  },
  articles: {
    title: 'Najnowsze artykuły',
    subtitle: 'Oryginalne poradniki, które pomogą Ci pewnie korzystać z arkusza USFans.',
    cardTitle: 'Arkusz USFans: kompletny poradnik',
    cardDesc: 'Przejrzysty przewodnik po tym, co obejmuje arkusz USFans, jak z niego korzystać i jak bezpiecznie robić zakupy — od kategorii po QC, wysyłkę i kupony.',
    readMore: 'Przeczytaj poradnik',
    tag: 'Poradnik',
  },
  faq: {
    title: 'Często zadawane pytania',
    q1: 'Czym jest arkusz USFans?',
    a1: 'To scentralizowane źródło, które gromadzi linki do produktów, kategorie, informacje QC, notatki o wysyłce i wskazówki zakupowe w jednym miejscu.',
    q2: 'Czy USFansLink.site to oficjalna strona USFans?',
    a2: 'Nie. To niezależne źródło informacji, które nie deklaruje oficjalnego powiązania.',
    q3: 'Jak korzystać z linków kategorii?',
    a3: 'Wybierz kategorię z listy rozwijanej lub przycisków kategorii, a następnie otwórz pasujący link, aby przeglądać produkty na głównej stronie.',
    q4: 'Czy ceny i koszty wysyłki są zawsze aktualne?',
    a4: 'Nie. Ceny, wysyłka i promocje mogą się zmieniać, więc zawsze weryfikuj je na stronie produktu przed płatnością.',
    q5: 'Czy zakupy są bezpieczne?',
    a5: 'Bezpieczeństwo zależy od weryfikacji sprzedawcy, czytania opinii i bezpiecznych metod płatności. Uważaj na nieznane linki i oferty, które wyglądają zbyt dobrze, by były prawdziwe.',
  },
  cta: {
    title: 'Gotowy, aby przeglądać pełny arkusz USFans?',
    body: 'Otwórz główną stronę, aby przeglądać produkty, sprawdzić QC i porównać opcje — wszystko w jednym miejscu.',
    button: 'Przejdź do głównej strony',
  },
  disclaimer: 'USFansLink.site to niezależne źródło informacji. Linki zewnętrzne, produkty, ceny, informacje o wysyłce i promocje mogą ulec zmianie. Zawsze weryfikuj aktualne informacje przed zakupem lub płatnością.',
  },
};